// extracted by mini-css-extract-plugin
export default {"container":"Feed_container__MRts-"};